import React, { useState, useEffect } from "react";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import moreIcon from "../../assets/images/DeathModuleNew/Menu.png";
import swal from "sweetalert";
import List from "../styledComponents/Table/List";
import { Modal } from "antd";
import CheckoutForm from "./CheckoutForm";
import { Invoices } from "./Invoices";
export const PaymentMethods = () => {
  const [loading, setLoading] = useState(false);
  const [paymentCards, setPaymentCards] = useState([]);
  const [defaultCard, setDefaultCard] = useState(null);

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [invioves, setInvioves] = useState(true);

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };
  const cols = [
    {
      title: "Card Last Four Digits",
      dataIndex: "last4",
      render: (record) => (record ? "****" + record : "N/A"),
    },
    {
      title: "Expiry",
      dataIndex: "expiry",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (fileName, record) => {
        return record.id ? (
          <div>
            {defaultCard && record.id === defaultCard.id ? "Default" : null}
          </div>
        ) : null;
      },
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            {" "}
            <img
              style={{ cursor: "pointer", marginLeft: "1rem" }}
              src={moreIcon}
              alt="moreIcon"
              onClick={() => {
                console.log("recode", record.id);
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
            ></img>{" "}
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        updateCard(record.id);
                        setDropdown(false);
                      }}
                    >
                      Make Default
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const getSelectedRow = (idx) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = paymentCards.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    // setUpdateObject(selectedRow[0]);
  };
  const deleteSelectedRow = async (idx) => {
    // var that = this;
    let res = null;
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this card?",
      dangerMode: true,
      buttons: ["No!", "Yes!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          res = await DEATH_API.deleteCustomerCard({ paymentMethod: idx });
          await getPaymentsList();
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Card Removed Successfully", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your card is safe :)", "error");
      }
    });
  };

  const updateCard = async (pmKey) => {
    try {
      setLoading(true);
      let datares = await DEATH_API.makeDefaultCard({ paymentMethod: pmKey });
      console.log("datares", datares);
      if (datares && datares.status === 200) {
        await getPaymentsList();
        swal("Success", datares.message, "success");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getPaymentsList = async () => {
    try {
      setLoading(true);
      let obj = [];
      let data = await DEATH_API.getCustomerCardsList();
      console.log("data cards", data);
      if (data && data.paymentMethods && data.paymentMethods.data) {
        data.paymentMethods.data.map((item, index) => {
          obj.push({
            id: item.id,
            last4: item.card.last4,
            exp_year: item.card.exp_year,
            exp_month: item.card.exp_month,
            expiry: item.card.exp_month + "/" + item.card.exp_year,
          });
        });

        setPaymentCards(obj);
      }
      if (data && data.defaultPaymentMethod) {
        setDefaultCard(data.defaultPaymentMethod);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    console.log("here in handle submit api cal");
    handleCloseModal();
    getPaymentsList();
  };

  useEffect(() => {
    console.log("calling api");
    getPaymentsList();
  }, []);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1
          style={{
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Payment Methods
        </h1>
        <button
          className="savebutton"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
            width: "150px",
          }}
          type="submit"
          onClick={handleOpenModal}
        >
          Add Card
        </button>
      </div>
      {modalVisible && (
        <Modal
          footer={null}
          closable={false}
          centered
          visible={modalVisible}
          onCancel={handleCloseModal}
        >
          <div style={{ marginTop: "20px" }}>
            <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}>
              {" "}
              Add Card
            </h3>
            <CheckoutForm close={handleCloseModal} submit={handleSubmit} />
          </div>
        </Modal>
      )}

      <div className="rolesTable" style={{ marginTop: "10px" }}>
        <div className="RolesHeader">
          <div className="RoleTitle">Payment Methods</div>
        </div>
        <List cols={cols} rows={paymentCards} />
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
